import {i18n} from './i18n';

export default i18n;

export {i18n};
export {FALLBACK_LANGUAGE} from './fallbackLanguage';
